import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { keys } from '@/lib/queryKeys';
import { fetchSubstitutionReport } from './api';
import type { SubstitutionReportType } from './types';

/** Branch-scoped, like useDayBook — a dispense happened at one physical
 * branch. Same date-range-as-part-of-the-key pattern for the same reason:
 * flipping back to a range (or type) already viewed is instant. */
export function useSubstitutionReport(type: SubstitutionReportType, from: string, to: string) {
  const { branchVersion } = useAuth();
  return useQuery({
    queryKey: [...keys.reports.pharmacySubstitutions(type, from, to), branchVersion],
    queryFn: () => fetchSubstitutionReport(type, from, to),
    enabled: !!from && !!to,
  });
}
